import axios from 'axios';
import '../config';


export const loginUser = async (credentials) => {
    // POST con cuerpo JSON: la contraseña no debe viajar en la URL
    return await axios.post(global.ruta+"/users/loginUser", credentials)
    .then(response => {
      
        sessionStorage.setItem('token',  response.data.token);
        sessionStorage.setItem('user',  response.data.datos.usuario);

        return response.data
    })
    .catch(err => {
      console.log(err)
      return err;
    })
      
  }

  export const getUser = async (user) => {

    const config = {
      headers: {
        Authorization: `Bearer ${window.sessionStorage.getItem("token")}`,
      },
    };

      return await axios.get(global.ruta+"/users/"+user, config)
      .then(response => {
       
          return response.data
      })
      .catch(err => {
        console.log(err)
      })
        
    }